import React, { useState, useEffect } from 'react';
import cl from './Style.module.css';
import AdminService from '../../API/AdminService';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../components/UI/Spinner/Spinner';
import PageIntro from '../../components/PageIntro/PageIntro';
import logger from '../../utils/logger';
const Events = () => {
    const navigate = useNavigate();
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Дни недели с соответствующими числовыми значениями
    const daysOfWeek = [
        { id: 1, name: 'Понедельник', shortName: 'Пн' },
        { id: 2, name: 'Вторник', shortName: 'Вт' },
        { id: 3, name: 'Среда', shortName: 'Ср' },
        { id: 4, name: 'Четверг', shortName: 'Чт' },
        { id: 5, name: 'Пятница', shortName: 'Пт' },
        { id: 6, name: 'Суббота', shortName: 'Сб' },
        { id: 0, name: 'Воскресенье', shortName: 'Вс' }
    ];

    // Загрузка курсов
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const coursesResponse = await AdminService.getAllEvents();

            // Показываем всё кроме завершённых (раньше был жёсткий whitelist
            // 'Активный' || пусто, который отсеивал любые кастомные статусы).
            const activeCourses = (coursesResponse.data || []).filter(
                course => course.status !== 'Завершённый'
            );

            logger.debug('[Events] всего', (coursesResponse.data || []).length, 'активных', activeCourses.length);
            setCourses(activeCourses);
        } catch (error) {
            logger.error('Ошибка загрузки данных:', error);
            setError('Ошибка загрузки расписания');
        } finally {
            setLoading(false);
        }
    };

    // Многодневные мероприятия (лагеря и серии): day < 0 или явный диапазон dateStart..dateEnd
    const multiDayEvents = courses
        .filter(course => course.day < 0 || (course.dateStart && course.dateEnd && course.dateStart !== course.dateEnd))
        .sort((a, b) => (a.dateStart || '').localeCompare(b.dateStart || ''));

    // Получить курсы для конкретного дня
    const getCoursesForDay = (dayId) => {
        const dayCourses = [];

        // Добавляем курсы для этого дня
        courses.forEach(course => {
            if (course.day === dayId) {
                dayCourses.push({
                    ...course,
                    type: 'course',
                    displayName: course.name,
                    startTime: course.timeStart,
                    endTime: course.timeEnd,
                    ageRange: course.ageRange || '8-12'
                });
            }
        });

        // Сортируем по времени начала
        return dayCourses.sort((a, b) => {
            if (!a.startTime && !b.startTime) return 0;
            if (!a.startTime) return 1;
            if (!b.startTime) return -1;
            return a.startTime.localeCompare(b.startTime);
        });
    };

    // Форматирование времени для отображения
    const formatTime = (timeStart, timeEnd) => {
        if (!timeStart && !timeEnd) return '';
        if (timeStart && timeEnd) return `${timeStart} - ${timeEnd}`;
        if (timeStart) return `${timeStart}`;
        return '';
    };

    // Форматирование дат курса
    const formatDateRange = (dateStart, dateEnd) => {
        if (!dateStart && !dateEnd) return '';
        if (dateStart && dateEnd && dateStart === dateEnd) return dateStart;
        if (dateStart && dateEnd) return `${dateStart} - ${dateEnd}`;
        if (dateStart) return `с ${dateStart}`;
        if (dateEnd) return `до ${dateEnd}`;
        return '';
    };

    if (loading) {
        return (
            <div className={cl.page_wrapper}>
                <Spinner size="large" text="Загрузка мероприятий" fullPage />
            </div>
        );
    }

    if (error) {
        return (
            <div className={cl.page_wrapper}>
                <div className={cl.wrap_content_1}>
                    <div className={cl.error}>{error}</div>
                </div>
            </div>
        );
    }

    // Обработка клика на курс
    const handleCourseClick = (course) => {
        navigate(`/main/events/event/${course.id}`);
    };

    // НОВОЕ: Проверка на отсутствие активных мероприятий
    if (courses.length === 0) {
        return (
            <div className={cl.pagewrapper}>
                <div className={cl.wrapcontent1}>
                    <PageIntro
                        storageKey="events"
                        title="О странице «Мероприятия»"
                        text="Разовые активности и серии, не связанные с регулярными курсами: летние лагеря, дни открытых дверей, мастер-классы, праздники."
                        bullets={[
                            'Мероприятия создаются в разделе «Настройки» вместе с курсами',
                            'Клик на карточку — журнал посещаемости и оплаты',
                            'Опция «Несколько» — для серий, которые идут не один день',
                        ]}
                    />
                    <div className={cl.emptyState}>
                        <div className={cl.emptyIcon}>
                            📅
                        </div>
                        <h2 className={cl.emptyTitle}>Нет активных мероприятий</h2>
                        <p className={cl.emptyDescription}>
                            В настоящее время не запланировано активных мероприятий. 
                            <br />
                            Создайте новые мероприятия в настройках для их отображения в расписании.
                        </p>
                        <div className={cl.emptyActions}>
                            <button 
                                className={cl.createEventButton}
                                onClick={() => navigate('/main/jornal/settings')}
                            >
                                ✨ Создать мероприятие
                            </button>
                            <button 
                                className={cl.refreshButton}
                                onClick={fetchData}
                            >
                                🔄 Обновить
                            </button>
                        </div>
                        <div className={cl.helpText}>
                            <p><strong>Совет:</strong> Мероприятия со статусом "Активный" будут показаны в расписании</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={cl.page_wrapper}>
            <div className={cl.wrap_content_1}>
                <h1>Расписание мероприятий</h1>
                <div className={cl.breadcrumbs}>
                    <span>АдминПанель / Расписание мероприятия</span>
                </div>

                <PageIntro
                    storageKey="events"
                    title="О странице «Мероприятия»"
                    text="Разовые активности и серии, не связанные с регулярными курсами: летние лагеря, дни открытых дверей, мастер-классы, праздники. Здесь они разложены по дням недели — или собраны в карточку «Несколько», если идут серией."
                    bullets={[
                        'Мероприятия создаются в разделе «Настройки» вместе с курсами',
                        'Клик на карточку — журнал посещаемости и оплаты по этому мероприятию',
                        'Опция «Несколько» — для серий, которые идут не один день (например, лагерь)',
                    ]}
                />

                {/* Многодневные мероприятия (лагеря, серии) — отдельным блоком */}
                {multiDayEvents.length > 0 && (
                    <div className={cl.multiDaySection}>
                        <h2 className={cl.multiDayTitle}>Многодневные мероприятия</h2>
                        <div className={cl.multiDayGrid}>
                            {multiDayEvents.map(course => (
                                <div
                                    key={`multi-${course.id}`}
                                    className={cl.courseCard}
                                    onClick={() => handleCourseClick(course)}
                                >
                                    <div className={cl.eventHeader}>
                                        <h4 className={cl.eventTitle}>{course.name}</h4>
                                        <span className={cl.eventType}>Серия</span>
                                    </div>
                                    <div className={cl.eventDetails}>
                                        <div className={cl.eventTime}>
                                            📅 {formatDateRange(course.dateStart, course.dateEnd)}
                                        </div>
                                        {(course.timeStart || course.timeEnd) && (
                                            <div className={cl.eventTime}>
                                                🕒 {formatTime(course.timeStart, course.timeEnd)}
                                            </div>
                                        )}
                                        {course.prepod && (
                                            <div className={cl.eventAge}>👨‍🏫 {course.prepod}</div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Сетка дней недели */}
                <div className={cl.scheduleGrid}>
                    {daysOfWeek.map(day => {
                        const dayEvents = getCoursesForDay(day.id);
                        const dayCourses = getCoursesForDay(day.id);
                        if (dayCourses.length != 0) {
                            return (
                                <div key={day.id} className={cl.dayColumn}>
                                    <div className={cl.dayHeader}>
                                        <h2>{day.name}</h2>
                                    </div>

                                    <div className={cl.dayContent}>
                                        {dayEvents.length === 0 ? (
                                            <div className={cl.noEvents}>
                                                Нет курсов
                                            </div>
                                        ) : (
                                            dayEvents.map((course) => (
                                                <div
                                                    key={`${course.type}-${course.id}`}
                                                    className={cl.courseCard}
                                                    onClick={() => handleCourseClick(course)}
                                                >
                                                    <div className={cl.eventHeader}>
                                                        <h4 className={cl.eventTitle}>
                                                            {course.displayName}
                                                        </h4>
                                                        <span className={cl.eventType}>
                                                            Курс
                                                        </span>
                                                    </div>

                                                    <div className={cl.eventDetails}>
                                                        <div className={cl.eventTime}>
                                                            🕒 {formatTime(course.startTime, course.endTime)}
                                                        </div>

                                                        {course.prepod && (
                                                            <div className={cl.eventAge}>
                                                                👨‍🏫 {course.prepod}
                                                            </div>
                                                        )}

                                                        
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            );
                        } 

                    })}
                </div>
            </div>
        </div>
    );
};

export default Events;